import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { NonEditableFormField } from "../../guests/components/form/FormFields";
import { PreCheckStatus } from "@/components/pages/settlement/types/settlementBooking";
import { formatStatusLabel } from "@/components/pages/reservations/utils/formatStatusLabel";
import { useTranslation } from "react-i18next";

const PreCheckStatusSelect = ({
  value,
  onChange,
  isEdit = true,
}: {
  isEdit?: boolean;
  value: PreCheckStatus;
  onChange: (value: string) => void;
}) => {
  const { t } = useTranslation();

  if (!isEdit) {
    return (
      <NonEditableFormField
        value={formatStatusLabel(value)}
        isCopy={false}
        label={t("reservation.precheckin.status")}
        labelClassName="text-foreground"
        contentClassName="h-9 mt-3 px-3 py-1 items-center border border-neutral-200 rounded-lg text-muted-foreground text-sm"
      />
    );
  }

  return (
    <div>
      <label className="block text-sm font-medium text-foreground mb-3">
        {t("reservation.precheckin.status")}
      </label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          className="w-full justify-start border border-neutral-200 rounded-lg focus-visible:border-ring data-[size=default]:h-9 aria-invalid:border-destructive cursor-pointer"
          showIcon={false}
        >
          <SelectValue
            placeholder={t("reservation.placeholders.chooseStatus")}
          />
        </SelectTrigger>
        <SelectContent>
          {Object.values(PreCheckStatus).map((statusValue) => (
            <SelectItem key={statusValue} value={statusValue}>
              <span className="text-muted-foreground">
                {formatStatusLabel(statusValue)}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default PreCheckStatusSelect;
